
import React, {useState } from 'react';

import styles from './ConfirmationScreen.module.css';
import helpers from '../../helpers.js';

import ScreenHeader from "../ScreenHeader.js";
import Module from "../Module.js";
import Button from "../Button.js";
import TermsAndConditions from "./TermsAndConditions.js";

import check from "../../assets/images/check.png";




function ConfirmationScreen(props) {
  const [formData, setFormData] = useState({
    pincharBags: 20,
    pelletcharBags: 9,
    billingPlan: "monthly"
  });
  const [displayOverlay, setDisplayOverlay] = useState(false);

  const handleChange = (formField, value) => {
    setFormData({ ...formData, [formField]: value });
  };

  return (
    <div className={helpers.clx("mainWhiteContainerContent", props.screenTransitioning ? "mainWhiteContainerContentHidden" : "")}>
          <ScreenHeader name={"Bulk Biochar Purchase"} content={"Ready to order? Get your biochar in just three steps: Choose how many bags you need, select a plan, and set up your payment."}/>
          <div className={"contentGrid"}>
            <Module spanColumn={24} spanRow={1} height={"74vh"}>
              <div className={styles.confirmationContent}>
                <img src={check} className={styles.checkIcon}/>
                <div className={styles.confirmationHeader}>
                  Order Request Received!
                </div>
                <div className={styles.confirmationText}>
                You will shortly receive a confirmation email with the relevant details of your request. If you have any questions, please reach out to us at <b>sales@blackbullbiochar.com</b>. Thank you for choosing BBB!
                </div>
                <div className={styles.buttonRow}>
                  <Button name="Back" onPress={() => props.goToScreen("subscription")} color="Coal"/>
                </div>
              </div>
            </Module>
          </div>
    </div>
  );
}

export default React.memo(ConfirmationScreen);
